(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product__related2"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_alternate__info"] && !Shopify.designMode) return;
  try {
    
(function () {
  function parseFreq(planName) {
    var m = planName.match(/(\d+)\s*(week|day|month)/i);
    if (!m) return null;
    var n = parseInt(m[1], 10);
    return n + ' ' + m[2].toLowerCase() + (n !== 1 ? 's' : '');
  }

  function syncFreq() {
    var sel = document.querySelector('.subscriptions__select');
    if (!sel || sel.selectedIndex < 0) return;
    var freq = parseFreq(sel.options[sel.selectedIndex].textContent);
    if (!freq) return;
    var els = document.querySelectorAll('[data-frequency-template]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = els[i].getAttribute('data-frequency-template').replace(/\{frequency\}/g, freq);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFreq);
  } else {
    syncFreq();
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList.contains('subscriptions__select')) {
      syncFreq();
    }
  });
})();

// Preselect the variant's default selling plan (window.defaultSellingPlans) on load and variant change
(function () {
  var FORMS = '.single-product-form, .quick-buy-product-form';

  function getVariantId(form) {
    var input = form.querySelector('[name="id"]:checked, select[name="id"], input[type="hidden"][name="id"]');
    return input ? input.value : null;
  }

  function applyDefaultPlan(form) {
    var plans = window.defaultSellingPlans;
    var select = form && form.querySelector('.subscriptions__select');
    if (!plans || !select) return;

    var planId = plans[getVariantId(form)];
    if (!planId || select.value === String(planId)) return;
    if (!select.querySelector('option[value="' + planId + '"]')) return;

    select.value = String(planId);
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function init() {
    document.querySelectorAll(FORMS).forEach(applyDefaultPlan);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // jQuery delegation also catches the custom dropdown's $('.variant-select').trigger('change')
  jQuery(document).on('change', '.single-product-form [name="id"], .quick-buy-product-form [name="id"]', function () {
    applyDefaultPlan(this.form);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
